import { prepHandleEvent } from "./prepHandleEvent";

export function handleMouseWheel(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;
  var isTouchEvent = false;
  var direction = false;
  if (event.wheelDelta) {
    //console.log(event.wheelDelta);
    direction = event.wheelDelta > -120;
  }
  if (event.deltaY) {
    //console.log(event.deltaY);
    direction = event.deltaY <= 0;
  }
  if (
    event.wheelDelta &&
    (event.wheelDelta + event.deltaY == 0 ||
      (event.deltaY && Math.abs(event.deltaY) < 99) ||
      event.wheelDelta === event.wheelDeltaX)
  ) {
    isTouchEvent = true;
  }

  if (!isTouchEvent) myApp.HandleMouseWheel(direction, event);
  else myApp.HandleTouch(event);
  event.stopPropagation();
}
